import { render, staticRenderFns } from "./category-preference.vue?vue&type=template&id=5484b409&"
import script from "./category-preference.vue?vue&type=script&lang=js&"
export * from "./category-preference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports